import {
  JobGrade,
  JobRootSpecialtyV2,
  JobSpeciality,
  JobSubSpeciality,
  WorkType,
} from '@/app/types/jobs';

import { JobContactGeneric } from './components/JobContactGeneric/JobContactGeneric';
import { JobContactSpecialist } from './components/JobContactSpecialist/JobContactSpecialist';
import {
  GetContactForJobProps,
  getContactForJob,
  getRegistrarSpecialistContact,
} from './components/getContactForJob';

type JobPointOfContactProps = {
  isLoggedIn?: boolean;
  jobNumber: string;
  specialty?: JobSpeciality | JobRootSpecialtyV2 | JobSubSpeciality;
  grade?: JobGrade;
  countryCode?: string; // AU, NZ etc.
  placementType: WorkType;
};

export const JobPointOfContact = ({
  jobNumber,
  isLoggedIn,
  specialty,
  grade,
  placementType,
  countryCode,
}: JobPointOfContactProps) => {
  const getSpecialistContactDetailsProp: GetContactForJobProps = {
    specialty,
    placementType,
    countryCode,
  };
  const specialistContactDetails =
    grade === 'Registrar'
      ? getRegistrarSpecialistContact(getSpecialistContactDetailsProp)
      : getContactForJob(getSpecialistContactDetailsProp);

  const shouldUseSpecialist = isLoggedIn && specialistContactDetails;

  return (
    <>
      {shouldUseSpecialist ? (
        <JobContactSpecialist jobNumber={jobNumber} {...specialistContactDetails} />
      ) : (
        <JobContactGeneric />
      )}
    </>
  );
};
